<template>
    <div class="mdui-container mdui-text-left" id="main-content">
        <div v-if="dataGot" class="mdui-row">
            <router-link :to="{name: 'yysLink', query:{key: 'yys'}}" tag="div" class="mdui-col-xs-12 mdui-col-lg-4" >
                <div class="my-card">
                    <img alt="XD" class="yys" :src="items[0].pic">
                    <div class="des-text mdui-text-center">
                        <h1>{{items[0].sort}}</h1>
                        <h2>{{items[0].status}}</h2>
                    </div>
                </div>
            </router-link>
            <router-link :to="{name: 'yysLink', query:{key: 'sp'}}" tag="div" class="mdui-col-xs-12 mdui-col-lg-4" >
                <div class="my-card">
                    <img alt="XD" class="sp" :src="items[1].pic">
                    <div class="des-text mdui-text-center">
                        <h1>{{items[1].sort}}</h1>
                        <h2>{{items[1].status}}</h2>
                    </div>
                </div>
            </router-link>
            <router-link :to="{name: 'yysLink', query:{key: 'ssr'}}" tag="div" class="mdui-col-xs-12 mdui-col-lg-4" >
                <div class="my-card">
                    <img alt="XD" class="ssr" :src="items[2].pic">
                    <div class="des-text mdui-text-center">
                        <h1>{{items[2].sort}}</h1>
                        <h2>{{items[2].status}}</h2>
                    </div>
                </div>
            </router-link>
            <router-link :to="{name: 'yysLink', query:{key: 'sr'}}" tag="div" class="mdui-col-xs-12 mdui-col-lg-4" >
                <div class="my-card">
                    <img alt="XD" class="sr" :src="items[3].pic">
                    <div class="des-text mdui-text-center">
                        <h1>{{items[3].sort}}</h1>
                        <h2>{{items[3].status}}</h2>
                    </div>
                </div>
            </router-link>
            <router-link :to="{name: 'yysLink', query:{key: 'r'}}" tag="div" class="mdui-col-xs-12 mdui-col-lg-4" >
                <div class="my-card">
                    <img alt="XD" class="r" :src="items[4].pic">
                    <div class="des-text mdui-text-center">
                        <h1>{{items[4].sort}}</h1>
                        <h2>{{items[4].status}}</h2>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
    
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Home",
        data(){
            return{
                title: "首页",
                items: [],
            }
        },
        props:{
            host:{
                require: true,
                type: String,
            }
        },
        methods:{
            getData(){
                axios.get(this.host + 'home')
                    .then((response) =>{
                        let data = response.data.data;
                        // console.log(response.data.data);
                        this.items = this.items.concat(data);
                        // console.log(this.items);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        },
        computed:{
          dataGot(){
              return this.items.length;
          }
        },
        beforeMount() {
            this.getData();
        },
        mounted() {
            this.$emit("titleChanged", this.title);
        }
    }
</script>

<style scoped>
    img{
        width: 250px;
        height: auto;
        display:block
    }
    img.yys{
        transform: translateX(-60px);
    }
    img.sp{
        transform: translateX(-40px);
    }
    img.ssr{
        transform: translateX(0px);
    }
    img.sr{
        transform: translateX(-25px);
    }
    img.r{
        transform: translateX(-20px);
    }
    .my-card{
        width: 100%;
        height: 100%;
        margin: 10px auto 0 auto;
        box-shadow: 0 1px 3px rgba(34, 25, 25, 0.2);
        padding: 0 0;
        overflow: hidden;
        cursor: pointer;
    }

    .des-text{
        float: right;
        display: block;
        width: 90px;
        height: auto;
        overflow: hidden;
        position: absolute;
        right:  1rem;
        top: 1rem;
    }

    /* For width 600px and larger: */
    @media only screen and (min-width: 1024px) {
        img{
            width: auto;
            height: 200px;
            display:block
        }
        img.yys{
            transform: translateX(-150px);
        }
        img.sp{
            transform: translateX(-80px);
        }
        img.ssr{
            transform: translateX(-50px);
        }
        img.sr{
            transform: translateX(-60px);
        }
        img.r{
            transform: translateX(-40px);
        }

        .des-text{
            right: 2.5rem;
            top: 2.5rem;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Home.vue